import React from "react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
} from "@chakra-ui/react";
import Select from "react-select";
import {
  newBorder,
  white,
  primary,
  textPrimary,
  textSecondary,
  primaryAlt,
  backgroundLight,
} from "../../utils/colors";
import { shade } from "polished";

const FormControlSelectEnum = ({
  label,
  labelFontSize,
  value,
  onChange,
  options,
  placeholder,
  isRequired,
  isTouched,
  isError,
  errorMessage,
  isDisabled,
  w,
  isClearable = true,
  menuPlacement,
}) => {
  const selectedOption = options.find((option) => option.value === value) || null;

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      color: textSecondary,
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: isError ? "red" : newBorder,
      backgroundColor: white,
      border: `1px solid ${newBorder}`,
      fontSize: "0.938rem",
      fontWeight: "500",
      minHeight: "3rem",
      height: "3rem",
      margin: 0,
      padding: "0 0.5rem",
      borderRadius: "0.75rem",
      boxShadow: state.isFocused ? `0 0 0 1px ${primary}` : "none",
      ":hover": {
        cursor: "pointer",
        borderColor: newBorder,
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0.75rem",
      boxShadow: "0px 0px 12px rgba(15, 23, 42, 0.15)",
      border: `0px solid ${newBorder}`,
      overflow: "hidden",
      zIndex: 90000,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      opacity: state.isDisabled ? 0.5 : 1,
      color: textPrimary,
      margin: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? primary
        : state.isFocused
        ? backgroundLight
        : white,
      color: state.isSelected ? white : textSecondary,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      margin: 0,
      padding: "0 1rem",
      fontWeight: "500",
      height: "48px",
      fontSize: "0.875rem",
      borderBottom: `1px solid ${newBorder}`,
      ":hover": {
        backgroundColor: state.isSelected
          ? shade(0.1, primary)
          : backgroundLight,
        color: state.isSelected ? white : primaryAlt,
      },
      ":last-of-type": {
        borderBottom: "none",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  return (
    <FormControl
      mb={4}
      isRequired={isRequired}
      isInvalid={isTouched && isError}
      w={w}
      isDisabled={isDisabled}
    >
      {label && (
        <FormLabel
          fontSize={labelFontSize ? labelFontSize : "sm"}
          color={textPrimary}
        >
          {label}
        </FormLabel>
      )}
      <Select
        value={selectedOption}
        onChange={(option) => onChange(option ? option.value : "")}
        options={options}
        placeholder={placeholder}
        isClearable={isClearable}
        isDisabled={isDisabled}
        styles={customStyles}
        menuPlacement={menuPlacement}
      />
      {isTouched && isError && errorMessage && (
        <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default FormControlSelectEnum;
